import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Change to useNavigate
import Header from '../../components/header1/Header1';
import Footer from '../../components/footer/Footer';
import bannerImage from '../../elements/hero-banner-login-page.png';
import mobileBannerImage from '../../elements/mobile_bg.png';
import { sendEmailToUserForPasswordReset } from "../../services/studentportalapis";
import Logo from "../../elements/Agivant-AMP-D-SE-Logo-Final 1.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [errorMessage, setErrorMessage] = useState(''); // State for error messages
  const [successMessage, setSuccessMessage] = useState(''); // State for success messages
  const navigate = useNavigate(); // Initialize useNavigate
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const handleForgotPassword = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    setErrorMessage(''); // Clear previous error messages
    setSuccessMessage(''); // Clear previous success messages
    setLoading(true); // Set loading state

    try {
      const response = await sendEmailToUserForPasswordReset(email);

      if (response.ok) {
        localStorage.setItem('email', email);
        setSuccessMessage('Email verified. Please proceed to the next step.'); // Success message
        // Optionally navigate after a delay
        setTimeout(() => {
          navigate('/reset');
        }, 2000);
      } else {
        // Handle different errors from backend response
        if (response.status === 404) {
          setErrorMessage('Email not found!');
        } else {
          setErrorMessage('Error resetting password. Please try again later.');
        }
      }
    } catch (error) {
      // Handle unexpected errors
      setErrorMessage('Email not found!');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="forgot-password">
      <Header />

      <div
        className="grid grid-cols-1 md:grid-cols-2 min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url(${isMobile ? mobileBannerImage : bannerImage})`,
        }}>
        {/* Left Side */}

        <div className="flex items-center justify-center px-4 ">
          <div className="px-6 sm:px-8 w-full max-w-md mx-auto">

            <div className='flex justify-center mb-2'>
              {isMobile && <img className='w-2/3 h-2/3' src={Logo} alt="Logo" />}
            </div>

            <h2 className="text-2xl sm:text-3xl text-white font-bold text-center mb-6">
              Reset Your Password
            </h2>
            <p className="text-center text-white mb-6">
              Enter your registered email to verify and continue.
            </p>

            <form onSubmit={handleForgotPassword}>
              {errorMessage && ( // Display error message if exists
                <div role="alert" className="mb-4 text-[#FFAA00] font-bold  text-center">{errorMessage}</div>
              )}
              {successMessage && ( // Display success message if exists
                <div role="alert" className="mb-4 text-green-400 font-semibold text-center">{successMessage}</div>
              )}

              <div className="mb-4 mt-2">
                <label htmlFor="email" className="block text-white font-semibold mb-2">
                  Email Id<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} // Update state on change
                  required // Add required validation
                />
              </div>

              <button
                type="submit" // Change to submit to trigger the form submission
                className="w-full bg-red-600 text-white p-3 rounded-md font-semibold hover:bg-red-700 transition"
                disabled={loading} // Disable button while loading
              >
                {loading ? 'Verifying...' : 'Verify Email'} {/* Change button text based on loading state */}
              </button>
            </form>

            <p className="text-center text-white mt-2 mb-2">
              Don't have an account?{' '}
              <a href="/register" className="text-indigo-200 hover:underline">Register here</a>
            </p>
          </div>
        </div>
        {/* Right Side (can remain empty or have background) */}
        <div className="hidden md:block"></div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
